(function() {
    'use strict';

    var wishlist = Cookies.getJSON('wishlist'),
        wishlistItems,
        wlSaved = 'saved-icon',
        wlUnsaved = 'unsaved-icon',
        wlTooltipMinWidth = 767,
        wlTooltipSaved = 'Saved! Select the heart in the header to view your list',
        wlTooltipFailed = 'Unable to save to your favourites list',
        wlTooltipUnsaved = 'Save to your favourites list',
        wlButtonRemove = 'data-wishlist-button-remove',
        wlButtonAdd = 'data-wishlist-button-add',
        toolTipHide;

    $(document).ready(function() {
        if (wishlist && wishlist.wishlistHasItems) {
            $('[data-wishlist-index-button]').each(function() {
                var svgHeaderIcon = $(this).find('svg');
                $(svgHeaderIcon).find('use').attr('xlink:href', $(this).data('item-exist-icon'));
            });
            $.ajax({
                url: '/favourites/items',
                success: function(data) {
                    wishlistItems = data;
                    processSavedDeals();
                }
            });
        } else {
            processSavedDeals();
        }
    });

    $(document).on('cdt.deals-loaded', function() {
        processSavedDeals();
    });

    var body = $('body');
    body.on('click', '[' + wlButtonAdd + ']', function(ev) {
        processWishlistStatus(ev, 'add-href', wlSaved, wlButtonAdd, wlButtonRemove);
    });

    body.on('click', '[' + wlButtonRemove + ']', function(ev) {
        processWishlistStatus(ev, 'remove-href', wlUnsaved, wlButtonRemove, wlButtonAdd);
    });

    body.on('click', '[data-wishlist-page-remove]', function(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var link = ev.currentTarget;
        $.ajax({
            url: $(link).attr('href'),
            success: function() {
                var listingTile = $(link).closest('[data-listing-tile]');
                listingTile.prev('[data-refurb-message]').fadeOut();
                listingTile.fadeOut();
            }
        });
    });

    function processWishlistStatus(event, urlTxt, iconStatus, removeAttr, addAttr) {
        event.preventDefault();
        event.stopPropagation();
        var href = event.currentTarget;
        $.ajax({
            url: $(href).data(urlTxt),
            success: function() {
                processWishlistFrontend(href, iconStatus, removeAttr, addAttr, true);
            },
            error: function() {
                processSavedWishlistTooltipHtml(href, wlTooltipFailed);
            }
        });
    }

    function processWishlistButtonHtml(href, iconStatus, removeAttr, addAttr, svgIcon) {
        var svgIconUse = $(svgIcon).find('use'),
            svgIconLink = $(href).data(iconStatus);
        $(href).removeAttr(removeAttr);
        $(href).attr(addAttr, '');
        $(svgIconUse).attr('xlink:href', svgIconLink);
    }

    function clearTooltipEvents(tooltipElem) {
        $(tooltipElem).off('mouseenter, mouseleave');
    }

    function addTooltipEvents(tooltipElem) {
        clearTooltipEvents(tooltipElem);
        $(tooltipElem).on('mouseenter', function() {
            if (window.innerWidth > wlTooltipMinWidth) {
                $(this).tooltip('show');
            }
        });
        $(tooltipElem).on('mouseleave', function() {
            if (window.innerWidth > wlTooltipMinWidth) {
                $(this).tooltip('hide');
            }
        });
    }

    function processSavedWishlistTooltipHtml(tooltipElem, text) {
        $(tooltipElem).attr('data-original-title', text);
        $(tooltipElem).tooltip('enable');
        $(tooltipElem).tooltip('show');
        toolTipHide = setTimeout(function() {
            $(tooltipElem).tooltip('hide');
            $(tooltipElem).tooltip('disable');
        }, 4000);
        toolTipHide;
    }

    function processUnsavedWishlistTooltipHtml(tooltipElem) {
        $(tooltipElem).attr('data-original-title', wlTooltipUnsaved);
        $(tooltipElem).tooltip('enable');
        addTooltipEvents(tooltipElem);
    }

    function processWishlistSaveAnimation(href, iconStatus, removeAttr, addAttr, svgIcon) {
        clearTooltipEvents(href);
        var $svgAnimation = $(svgIcon).clone(true),
            svgIconLink = $(href).data(iconStatus);
        $svgAnimation.addClass('heart-animation');
        $svgAnimation.find('use').attr('xlink:href', svgIconLink);
        $svgAnimation.one('animationend webkitAnimationEnd', function() {
            processWishlistButtonHtml(href, iconStatus, removeAttr, addAttr, svgIcon);
            $(this).remove();
            processSavedWishlistTooltipHtml(href, wlTooltipSaved);
        });
        $(svgIcon).parent().append($svgAnimation);
    }

    function processWishlistFrontend(href, iconStatus, removeAttr, addAttr, animation) {
        var svgIcon = $(href).find('svg')[0];
        clearTimeout(toolTipHide);
        $('[data-wishlist-button]').tooltip('hide');
        $(href).tooltip('disable');
        if (animation && iconStatus === wlSaved) {
            processWishlistSaveAnimation(href, iconStatus, removeAttr, addAttr, svgIcon);
            return;
        }
        if (iconStatus === wlUnsaved) {
            processUnsavedWishlistTooltipHtml(href);
        }
        processWishlistButtonHtml(href, iconStatus, removeAttr, addAttr, svgIcon);
    }

    function processSavedDeals() {
        $('[data-wishlist-button]').each(function() {
            if (wishlistItems && $.inArray($(this).data('dealid'), wishlistItems) !== -1) {
                processWishlistFrontend(this, wlSaved, wlButtonAdd, wlButtonRemove);
            } else {
                processWishlistFrontend(this, wlUnsaved, wlButtonRemove, wlButtonAdd);
                addTooltipEvents(this);
            }
        });
    }

})($);
